<template>
    <div>
        <data-grid
            url="broadcast"
            :columns="columns"
            :title="title"
            :headerMessage="lastUpdated"
            :actions="actions"
            :onRowClicked="onRowClick"
            navigationPath="navigationPath"
            navigationField="navigationField"
            ref="grid"
            :sortOptions="{
                enabled: true,
                field: 'active',
                type: 'asc',
            }"
        ></data-grid>
        <v-dialog v-model="updateNumberDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline pb-0">{{
                    rowClicked ? "Update Number" : "New Number"
                }}</v-card-title>
                <v-card-actions>
                    <v-layout column>
                        <v-text-field
                            class="mb-0"
                            label="Number"
                            v-model="number"
                            ref="number"
                            :rules="[rules.required, rules.phoneNumber]"
                        ></v-text-field>
                        <v-text-field
                            class="mb-2"
                            label="Description"
                            v-model="description"
                            ref="description"
                            :rules="[rules.required]"
                        ></v-text-field>

                        <div class="text-xs-right">
                            <v-spacer></v-spacer>
                            <v-btn
                                color="default"
                                dark
                                @click="updateNumberDialog = false"
                                >Cancel</v-btn
                            >
                            <v-btn
                                v-if="rowClicked"
                                color="default"
                                dark
                                @click="deleteNumber"
                                >Delete</v-btn
                            >
                            <v-btn
                                :loading="processing"
                                color="success"
                                @click="saveNumber"
                            >
                                save
                            </v-btn>
                        </div></v-layout
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            color="warning"
            top
            right
            :timeout="snackbarTimeout"
            v-model="snackbar"
            dark
        >
            <v-layout column>
                <div class="headline mb-2">
                    The Following Numbers We're Deleted
                </div>
                <div class="">{{ deletedNumbers }}</div>
            </v-layout>
            <v-icon size="16" @click="snackbar = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </div>
</template>

<script>
import { formatCurrency, formatPhoneNumber } from "../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        title: "Phone Numbers",
        phoneMask: "#(###) ### - ####",

        lastUpdated: "",
        snackbar: false,
        snackbarTimeout: 0,
        deletedNumbers: "",
        actions: [],
        processing: false,
        rowClicked: "",

        updateNumberDialog: false,
        number: "",
        description: "",
        rules: {
            required: (value) => !!value || "Required.",
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },

        columns: [
            {
                sortable: true,
                label: "Number",
                field: "number",
                width: "150px",
                formatFn: (value) => {
                    return value.replace(
                        /(\d{1})(\d{3})(\d{3})(\d{4})/,
                        "$1 ($2) $3-$4",
                    );
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Description",
                field: "description",
                width: "150px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Status",
                field: "active",
                width: "125px",
                type: "boolean",
                formatFn: (value, row) => {
                    return !row.carrier
                        ? "Active"
                        : value
                        ? "Active"
                        : "Inactive";
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select Status",
                    filterDropdownItems: [
                        { value: true, text: "Active" },
                        { value: false, text: "Inactive" },
                    ],
                },
            },
            {
                sortable: true,
                label: "Created",
                field: "createdAt",
                width: "150px",
                type: "date",
                dateOutputFormat: "MM/DD/YYYY",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Emails",
                field: "emails",
                width: "150px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Forward Number",
                field: "forwardNumber",
                width: "200px",
                formatFn: (value) => {
                    return value
                        ? value.replace(
                              /(\d{1})(\d{3})(\d{3})(\d{4})/,
                              "$1 ($2) $3-$4",
                          )
                        : "";
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "App Description",
                field: "appDescription",
                width: "200px",
                isDropdown: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterDropdownItems: [],
                },
            },
            {
                sortable: true,
                label: "Carrier",
                field: "carrier",
                width: "150px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select Carrier",
                    filterDropdownItems: ["PLIVO", "BANDWIDTH"],
                },
            },
            {
                sortable: true,
                label: "User",
                field: "user",
                width: "150px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Record Calls",
                field: "recordCalls",
                width: "150px",
                type: "boolean",
                formatFn: (value) => (value ? "Yes" : "No"),
                hidden: true,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select",
                    filterDropdownItems: [
                        { value: true, text: "Yes" },
                        { value: false, text: "No" },
                    ],
                },
            },
            {
                sortable: true,
                label: "To Communication Tab",
                field: "toCommunicationTab",
                type: "boolean",
                width: "200px",
                formatFn: (value) => (value ? "Yes" : "No"),
                hidden: true,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select",
                    filterDropdownItems: [
                        { value: true, text: "Yes" },
                        { value: false, text: "No" },
                    ],
                },
            },
            {
                sortable: true,
                label: "To Voicemail",
                field: "toVoicemail",
                type: "boolean",
                width: "150px",
                formatFn: (value) => (value ? "Yes" : "No"),
                hidden: true,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select",
                    filterDropdownItems: [
                        { value: true, text: "Yes" },
                        { value: false, text: "No" },
                    ],
                },
            },
            {
                sortable: true,
                label: "Send Undelivered Report",
                field: "undeliveredReport",
                type: "boolean",
                width: "250px",
                formatFn: (value) => (value ? "Yes" : "No"),
                hidden: true,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select",
                    filterDropdownItems: [
                        { value: true, text: "Yes" },
                        { value: false, text: "No" },
                    ],
                },
            },
            {
                sortable: true,
                label: "Verified By Twilio",
                field: "verifiedByTwilio",
                type: "boolean",
                width: "250px",
                formatFn: (value) => (value ? "Yes" : "No"),
                hidden: true,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select",
                    filterDropdownItems: [
                        { value: true, text: "Yes" },
                        { value: false, text: "No" },
                    ],
                },
            },
        ],
    }),
    async created() {
        this.columns.find(
            (c) => c.field == "active",
        ).tdClass = this.formatStatusColumn;

        await this.syncNumbers();

        this.actions.push({
            text: "Add Number",
            action: this.addNumber,
        });
    },
    methods: {
        async syncNumbers() {
            const response = await this.$http.get("api/broadcast/syncNumbers");

            this.lastUpdated = "Last Updated: " + moment().format("LLL");

            if (this.$refs.grid) {
                this.$refs.grid.load();
            }

            const deletedNumbers = response.map((r) => r.deleted).flat();

            if (deletedNumbers.length) {
                this.snackbar = true;
                this.deletedNumbers = deletedNumbers
                    .map(formatPhoneNumber)
                    .join(", ");
            }
        },
        formatStatusColumn(row) {
            if (!row.active) {
                return "red-text-color";
            }

            return "default-text-color";
        },
        onRowClick(row) {
            if (row.carrier) {
                this.$router.push({
                    name: "Phone Detail",
                    params: { id: row.number },
                });
                return;
            }

            this.rowClicked = row;
            this.description = row.description;
            this.number = row.number;

            this.updateNumberDialog = true;
        },
        addNumber() {
            this.description = "";
            this.number = "";
            this.rowClicked = "";

            this.updateNumberDialog = true;
        },
        async saveNumber() {
            if (
                !this.$refs.number.validate(true) ||
                !this.$refs.description.validate(true)
            )
                return;

            const today = moment().format("YYYY-MM-DD HH:mm:ss");

            this.processing = true;

            const data = {
                number:
                    this.number.length == 11
                        ? this.number.replace("-", "")
                        : "1" + this.number.replace("-", ""),
                createdAt: today,
                description: this.description,
                active: true,
                user: this.$store.state.authentication.user,
            };

            try {
                await this.$http.post("api/broadcast/savePhoneNumber", data);

                this.$notify({
                    text: "Number Saved",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;
                this.updateNumberDialog = false;

                if (this.$refs.grid) {
                    this.$refs.grid.load();
                }
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteNumber() {
            await this.$http.post(
                "api/broadcast/delete?phoneNumber=" + this.number,
            );

            this.$notify({
                text: "Number deleted",
                group: "notification",
                type: "success",
            });

            this.updateNumberDialog = false;

            if (this.$refs.grid) {
                this.$refs.grid.load();
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.red-text-color {
    color: red !important;
}
.default-text-color {
    color: black;
}
</style>
